function Table({ title, rows, cols, empty, testId }) {
  return (
    <div className="rounded-lg border border-border bg-card p-3" data-testid={testId}>
      <div className="text-xs font-semibold mb-2">{title}</div>
      {!rows?.length ? <p className="text-xs text-muted-foreground">{empty}</p> : (
        <table className="w-full text-xs">
          <thead><tr className="text-left text-muted-foreground">{cols.map((c) => <th key={c.key} className={`py-1 font-medium ${c.right ? "text-right" : ""}`}>{c.label}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.route} className="border-t border-border/60" data-testid={`${testId}-row`}>
                {cols.map((c) => <td key={c.key} className={`py-1 ${c.right ? "text-right tabular-nums" : "font-mono truncate max-w-[280px]"}`} title={c.key === "route" ? r.route : undefined}>{c.fmt ? c.fmt(r[c.key], r) : r[c.key]}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const ms = (v) => `${Math.round(v)} ms`;

export function EndpointTables({ routes }) {
  return (
    <div className="grid gap-4 lg:grid-cols-3" data-testid="system-endpoints">
      <Table title="Slowest endpoints" testId="endpoints-slowest" rows={routes?.slowest} empty="No endpoint has had 3+ calls in this range yet."
        cols={[{ key: "route", label: "Endpoint" }, { key: "n", label: "Calls", right: true }, { key: "avg_ms", label: "Avg", right: true, fmt: ms }, { key: "max_ms", label: "Max", right: true, fmt: ms }]} />
      <Table title="Endpoints with server errors" testId="endpoints-failing" rows={routes?.failing} empty="No 5xx errors in this range."
        cols={[{ key: "route", label: "Endpoint" }, { key: "n", label: "Calls", right: true }, { key: "err5", label: "5xx", right: true }, { key: "error_rate", label: "Rate", right: true, fmt: (v) => `${v}%` }]} />
      <Table title="Busiest endpoints" testId="endpoints-busiest" rows={routes?.busiest} empty="No traffic recorded in this range yet."
        cols={[{ key: "route", label: "Endpoint" }, { key: "n", label: "Calls", right: true }, { key: "err4", label: "4xx", right: true }, { key: "avg_ms", label: "Avg", right: true, fmt: ms }]} />
    </div>
  );
}
